import { Box } from "@chakra-ui/layout";
import { Container } from "components";
import { SimpleGrid, Text, Divider, Stack } from "@chakra-ui/react";
import { PageSectionHeading } from "components/molecules/PageSection";
import { PricingCard } from "./components/PriceCard";
import { PageTitle } from "components/molecules/PageTitle";
import { PressBanner } from "components/molecules/PressBanner";
import { CenterTestimonial } from "components/molecules/CenterTestimonial";
import { NavigationPageSpacer } from "components/organisms/Navigation";
import { IFAQ } from "interfaces/faq.interface";
import { NextSeo } from "next-seo";
import { useAppContext } from "pages/_app";

import { FAQItem } from "components/molecules/FAQ";
import { CSSColumns } from "components/atoms/CSSColumns";

export const Pricing = ({ faqs }: { faqs: IFAQ[] }) => {
  const {
    products: {
      IVT,
      LeadResponder,
      Autocaller,
      FacebookAdvertising,
      Dashboard,
      Mortgages,
    },
  } = useAppContext();

  return (
    <>
      <NextSeo title="Pricing" />

      <Box py={{ base: 12, lg: 24 }}>
        <NavigationPageSpacer />
        <Box pt={0}>
          <Container>
            <Box mb={12} textAlign="center">
              <PageTitle>Monthly Pricing</PageTitle>
            </Box>
          </Container>
        </Box>
        <Box>
          <Container>
            <Box mb={8}>
              <SimpleGrid
                columns={{ base: 1, lg: 3 }}
                spacing={{ base: 4, lg: 12 }}
              >
                <Box>
                  <PricingCard product={IVT} />
                </Box>
                <Box>
                  <PricingCard product={LeadResponder} />
                </Box>
                <Box>
                  <PricingCard product={Autocaller} />
                </Box>
                <Box>
                  <PricingCard product={FacebookAdvertising} />
                </Box>
                <Box>
                  <PricingCard product={Dashboard} />
                </Box>
                <Box>
                  <PricingCard product={Mortgages} />
                </Box>
              </SimpleGrid>
            </Box>
            <Text
              maxW="3xl"
              mx="auto"
              fontSize="lg"
              lineHeight="1.8"
              textAlign="center"
              color="gray.700"
            >
              ** All accounts include 1 user. Each additional user is charged at
              £16 per month.
            </Text>
            <Divider my={16} />
            <CenterTestimonial />
            <PressBanner />
            <Divider my={16} />
            <Box maxW="5xl" mx="auto">
              <PageSectionHeading mb={6}>
                Questions &amp; answers
              </PageSectionHeading>
              <CSSColumns
                columnCount={{ base: 1, lg: 2 }}
                columnGap={{ base: 0, lg: 32 }}
                maxW="5xl"
                mx="auto"
              >
                {faqs &&
                  faqs.map((faq, index) => {
                    return (
                      <Box mb={8} key={index}>
                        <FAQItem title={faq.question}>{faq.answer}</FAQItem>
                      </Box>
                    );
                  })}
              </CSSColumns>
            </Box>
          </Container>
        </Box>
      </Box>
    </>
  );
};
